import { ActionIcon } from '@mantine/core';
import { Icons } from '../Shares/Icons';
export type SocialMenuItemProps = {
  icon: string;
};
export const SocialMenuItem: React.FC<SocialMenuItemProps> = ({
  icon
}) => {
  return <ActionIcon variant="transparent">
      <Icons className={icon} color="var(--mantine-color-dark-9)" fontSize={24} />
    </ActionIcon>;
};